<template>
	<section class="section-table">
		<pagination
			class="pagination-top"
			:total="applicationsAccessLogs.total"
			:page.sync="applicationsAccessLogs.current_page"
			:limit.sync="applicationsAccessLogs.per_page"
			@pagination="fetchAccessLogs(false)"
			@sizeChange="fetchAccessLogs(true)"
			:separate-change="true"
			:page-sizes="[5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100, 200, 300, 400, 500]"
			:slotStacked="true"
			slotPosition="after">

			<el-button type="primary" @click="exportLogs" :loading="this.exportLoading">
				<span><i class="fas fa-file-excel"></i></span> <span class="pl-1">Export Logs</span>
			</el-button>

			<!-- <x-modal
				:wWidth="1080"
				v-if="showModalFilter === true"
				@cancel="showModalFilter = false"
				@ok="exportLogs()"
			>
				<h3>Number of Reports</h3>
				<el-select class="mt-2 border-none" type="number" v-model="reportNumber" clearable>
						<el-option
						v-for="option in reportOptions"
						:key="option.value"
						:value="option.value"
						:label="option.label"
						/>
				</el-select>
			</x-modal> -->

            <el-select collapse-tags multiple clearable filterable style="width: 250px" size="small" v-model="filter.brokerIds" placeholder="Filter By Brokers">
                <el-option
                    v-for="broker in brokers"
                    :key="broker.id"
                    :label="broker.full_name"
                    :value="broker.id">
                </el-option>
            </el-select>

            <el-select v-if="Ambition.teamsEnabled()" collapse-tags multiple clearable filterable style="margin-left: 10px; width: 250px" size="small" v-model="filter.teamIds" placeholder="Filter By Teams">
                <el-option
                    v-for="team in userTeams"
                    :key="team.id"
                    :label="team.name"
                    :value="team.id">
                </el-option>
            </el-select>

            <el-select collapse-tags clearable filterable style="margin-left: 10px; width: 250px" size="small" v-model="filter.status" placeholder="Filter By Status">
                <el-option
                    label="Open"
                    value="open">
                </el-option>
                <el-option
                    label="Closed"
                    value="closed">
                </el-option>
            </el-select>

            <el-date-picker
                style="margin-left: 10px; width: 450px"
                v-model="filter.dateRange"
                type="datetimerange"
                :picker-options="pickerOptions"
                range-separator="To"
                start-placeholder="Start date"
                end-placeholder="End date"
                align="right"
                size="small">
            </el-date-picker>

        </pagination>

		<el-table
			:row-key="setRowKeys"
			:key="_.size(tableData)"
			border
			v-loading="tableLoading"
			:data="tableData"
			style="width: 100%"
		>
			<el-table-column prop="application.ref_id" label="Application">
				<template slot-scope="scope">
					<a
						v-if="scope.row.application"
						:href="'/admin/applications/' + scope.row.application.id + '/stage/application'"
						:target="scope.row.application.ref_id"
					>
						#{{ scope.row.application.ref_id }}
					</a>
				</template>
			</el-table-column>

			<el-table-column prop="is_closed" label="Application Status">
				<template slot-scope="scope">
					{{ scope.row.is_closed ? "Closed" : "Open" }}
				</template>
			</el-table-column>

			<el-table-column prop="application.broker.full_name" label="Application Broker"></el-table-column>

			<el-table-column v-if="Ambition.teamsEnabled()" prop="application.team.name" label="Application Team"></el-table-column>

			<el-table-column prop="broker.full_name" label="Accessed By"></el-table-column>

			<el-table-column prop="created_at" label="First Accessed" :formatter="formatDate"></el-table-column>

			<el-table-column prop="updated_at" label="Last Accessed" :formatter="formatDate"></el-table-column>

			<el-table-column prop="hits" label="Access Count"></el-table-column>
		</el-table>

		<pagination
			class="pagination-bottom"
			:total="applicationsAccessLogs.total"
			:page.sync="applicationsAccessLogs.current_page"
			:limit.sync="applicationsAccessLogs.per_page"
			@pagination="fetchAccessLogs(false)"
			@sizeChange="fetchAccessLogs(true)"
			:separate-change="true"
			:page-sizes="[5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100, 200, 500]"
			:slotStacked="true"
			slotPosition="before">

            <el-select collapse-tags multiple clearable filterable style="width: 250px" size="small" v-model="filter.brokerIds" placeholder="Filter By Brokers">
                <el-option
                    v-for="broker in brokers"
                    :key="broker.id"
                    :label="broker.full_name"
                    :value="broker.id">
                </el-option>
            </el-select>

            <el-select v-if="Ambition.teamsEnabled()" collapse-tags multiple clearable filterable style="margin-left: 10px; width: 250px" size="small" v-model="filter.teamIds" placeholder="Filter By Teams">
                <el-option
                    v-for="team in userTeams"
                    :key="team.id"
                    :label="team.name"
                    :value="team.id">
                </el-option>
            </el-select>

            <el-select collapse-tags clearable filterable style="margin-left: 10px; width: 250px" size="small" v-model="filter.status" placeholder="Filter By Status">
                <el-option
                    label="Open"
                    value="open">
                </el-option>
                <el-option
                    label="Closed"
                    value="closed">
                </el-option>
            </el-select>

            <el-date-picker
                style="margin-left: 10px; width: 450px"
                v-model="filter.dateRange"
                type="datetimerange"
                :picker-options="pickerOptions"
                range-separator="To"
                start-placeholder="Start date"
                end-placeholder="End date"
                align="right"
                size="small">
            </el-date-picker>

        </pagination>
	</section>
</template>

<script>
	import { mapGetters } from "vuex"
	import Pagination from "@shared/components/pagination"
	export default {
		name: "ApplicationsAccessLogs",
		components: {
			Pagination,
		},
		props: {
			accessLogs: {
				type: Object,
				required: false,
				default: function () {
					return {}
				},
			},
            brokers: {
                type: Array,
                required: true
            },
            userTeams: {
                required: false,
                type: Array,
                default: function() {
                    return []
                }
            }
		},

		data() {
			return {
				applicationsAccessLogs: [],
				tableLoading: false,
				exportLoading: false,
				abortController: null,
				reportNumber: "",
				reportOptions: [
					{ value: 5, label: '5' },
					{ value: 10, label: '10' },
					{ value: 15, label: '15' },
					{ value: 20, label: '20' },
					{ value: 25, label: '25' },
					{ value: 30, label: '30' },
					{ value: 35, label: '35' },
					{ value: 40, label: '40' },
					{ value: 45, label: '45' },
					{ value: 50, label: '50' },
					{ value: 100, label: '100' },
					{ value: 200, label: '200' },
					{ value: 500, label: '500' },
				],
                filter: {
                    brokerIds: [],
                    teamIds: [],
                    status: null,
                    dateRange: [],
                },
                filterTimeout: null,
				filterTimeoutWait: 1500,
				showModalFilter: false,
                pickerOptions: {
					shortcuts: [
						{
							text: "Last week",
							onClick(picker) {
								const end = new Date()
								const start = new Date()
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
								picker.$emit("pick", [start, end])
							},
						},
						{
							text: "Last month",
							onClick(picker) {
								const end = new Date()
								const start = new Date()
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
								picker.$emit("pick", [start, end])
							},
						},
						{
							text: "Last 3 months",
							onClick(picker) {
								const end = new Date()
								const start = new Date()
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
								picker.$emit("pick", [start, end])
							},
						},
					],
				},
			}
		},

		mounted() {},

		computed: {
			...mapGetters({
				user: "user/user",
			}),
			tableData() {
				if (_.isEmpty(this.applicationsAccessLogs)) return []
				return this.applicationsAccessLogs.data
			},

		},

		methods: {
			exportLogs(){
				let dataArray = []
				let applicationCatagory = []
				let appStatus = []

				applicationCatagory.push('\n', 'APPLICATION', 'APPLCIATION STATUS', 'APPLICATION BROKER', 'APPLICATION TEAM', 'ACCESSED BY', 'FIRST ACCESSED', 'LAST ACCESSED', 'ACCESS COUNT');
				dataArray.push(_.map(this.tableData, 'application.ref_id'));
				
				_.map(this.tableData, 'application.status').forEach((item)=>{
					appStatus.push(item === 0 ? 'Open' : 'Close');
				})

				dataArray.push(appStatus);
				dataArray.push(_.map(this.tableData, 'application.broker.full_name'));
				dataArray.push(_.map(this.tableData, 'application.teams.0.name'));
				dataArray.push(_.map(this.tableData, 'broker.full_name'));
				dataArray.push(_.map(this.tableData, 'created_at'));
				dataArray.push(_.map(this.tableData, 'updated_at'));
				dataArray.push(_.map(this.tableData, 'hits'));

				for (let i = 0; i < _.map(this.tableData, 'application.ref_id').length; i++){
					applicationCatagory.push('\n')
					dataArray.forEach((column) => {
						applicationCatagory.push(column[i])
					})
				}

				let fileURL = window.URL.createObjectURL(new Blob([applicationCatagory], { type: 'text/csv;charset=utf-8;' }))
				let fileLink = document.createElement('a')
				fileLink.href = fileURL
				fileLink.setAttribute('download', 'application_access_logs.csv')
				document.body.appendChild(fileLink)
				fileLink.click()
			},

			setRowKeys(row) {
				return row.id
			},
			formatDate(row, column, cellValue, index) {
				let timezone = _.get(this.user, "timezone", Intl.DateTimeFormat().resolvedOptions().timeZone)
				return this.$moment.utc(cellValue).tz(timezone).format("ddd DD/MM/YY LT")
			},
			cancelFetch() {
				if (this.abortController) {
					this.abortController.abort()
				}
			},
			fetchAccessLogs(resetPage) {
				this.cancelFetch()
				this.abortController = new AbortController();
				this.commitFetch(resetPage)
			},
			commitFetch(resetPage) {
				if (resetPage) {
					this.applicationsAccessLogs.current_page = 1
				}

				let data = {
					page: this.applicationsAccessLogs.current_page,
					per_page: this.applicationsAccessLogs.per_page,
                    filter: _.omitBy(this.filter, _.isEmpty),
				}

                this.tableLoading = true

				axios
					.post("/admin/v2/applications-access-logs/fetch-logs", data, {
						signal: this.abortController.signal,
					})
					.then((res) => {
						this.applicationsAccessLogs = res.data
					})
					.catch((err) => {
						if (!axios.isCancel(err)) {
							console.error(err)
						}
					})
                    .finally(() => {
                        this.tableLoading = false
                    })
			},
		},

		watch: {
			accessLogs: {
				handler(accessLogs) {
					if (!_.isEmpty(accessLogs.data)) {
						this.applicationsAccessLogs = accessLogs
					}
				},
				immediate: true,
				deep: true,
			},
            filter: {
				handler() {
					if (this.filterTimeout) clearTimeout(this.filterTimeout)
					this.filterTimeout = setTimeout(() => {
						this.fetchAccessLogs(true)
					}, this.filterTimeoutWait)
				},
                deep: true,
			},
		},
	}
</script>

<style lang="scss" scoped>
	.section-table {
		background-color: #f0f3f5;
		border: 1px solid #c2cfd6;
		padding: 10px;

		.pagination-container {
			border: 1px solid #dcdfe6;
			border-radius: 5px;
			padding: 10px !important;

			&.pagination-top {
				margin-bottom: 10px !important;
			}

			&.pagination-bottom {
				margin-top: 10px !important;
				margin-bottom: 0 !important;
			}

			.el-pager {
				li {
					background-color: transparent;
					border: 1px solid #dcdfe6;
					font-weight: 400;

					&.active {
						background-color: #69c23a;
						border: none;
					}
				}
			}
		}

		.el-table {
			border: 1px solid #dcdfe6;
			border-radius: 5px;

			// .el-table__row {
			// 	cursor: pointer;
			// }

			.el-table__expanded-cell {
				background: #ffffff;
				box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.7) inset;
			}

			.cell {
				word-break: break-word;
			}
		}
	}

	.el-form-item__label {
		width: 100%;
		text-align: left;
	}
</style>